export default __webpack_public_path__ + "static/media/cafe_1.ce9978b9.jpg";